/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Typography, Container, Box, Button, TextField, alpha } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { useState } from "react";

import { useTranslation } from 'react-i18next';
import { toast,} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import MainLogo from "../images/digiacc.png";
import Wallpaper from "../images/acc4.jpg";
import AuthenticationService from '../../service/AuthenticationService';
import { useNavigate, useParams } from 'react-router-dom';

const logoMain = css({
    height: "2.2rem",
})

const NewPasswordRoute = (): JSX.Element => {

    const theme = useTheme();

    const { t, i18n } = useTranslation();

    const navigate = useNavigate();

    const { token } = useParams();

    const [loginMessage, setLoginMessage] = useState<string>("");
    const [isReset, setIsReset] = useState(false);

    //##########################################################################################################

    const postResetButton = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const handleChangePassword = async () => {
            const loginService = new AuthenticationService();

            const newPassword = data.get("newPassword") as string;
            const reNewPassword = data.get("reNewPassword") as string;

            if (newPassword !== "" && reNewPassword !== "") {
                if (newPassword === reNewPassword) {

                    const result = await loginService.postResetPassword(token ? token : "", newPassword);

                    if (result.hasErrors) {
                        toast(t("basic.loginError"));
                        if (result.value.passwordNotMeetingComplexityRequirements) {
                            toast(t("basic.newPasswordNotMeetingRequirements"));
                        }
                    } else if (result.value.passwordNotMeetingComplexityRequirements) {
                        toast(t("basic.newPasswordNotMeetingRequirements"));
                    } else {
                        toast(t("basic.passwordChangedSuccessfully"));
                        setLoginMessage(t("basic.passwordChangedSuccessfully"));
                        setIsReset(true);
                    }
                }
                else {
                    toast(t("basic.passwordsNotIdentical"));
                }
            }
            else {
                toast(t("basic.passwordMissing"));
            }
        };
        handleChangePassword();
    }

    //########################################################################################
    //########################################################################################
    if (isReset) {
        return <main>
            <Grid container direction="column"
                sx={{
                    width: "100%",
                    minHeight: "30rem",
                    height: "calc(100vh)",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundImage: "url(" + Wallpaper + ")",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                    //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
                }}>
                <Container sx={{
                    bgcolor: alpha(theme.palette.background.paper, 0.9),
                    minHeight: "20rem",
                    padding: theme.spacing(4), borderRadius: theme.shape.borderRadius, border: 1,
                }} maxWidth="xs">
                    <Box sx={{
                        marginTop: "1rem",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        <Box
                            component={Button}
                            sx={{
                                display: "flex",
                                justifyContent: "center", alignItems: "center", width: "100%",
                            }}>
                            <img src={MainLogo} css={logoMain} />
                        </Box>
                        <Box sx={{ marginTop: theme.spacing(1) }}>
                            <Typography color={theme.palette.error.main}>{loginMessage}</Typography>
                            <Button
                                onClick={() => window.location.replace("/")}
                                fullWidth
                                variant="contained"
                                color="primary"
                                sx={{ mt: theme.spacing(3), mb: theme.spacing(2) }}>
                                {t('basic.goBacktoLogin')}
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Grid>
        </main>
    } else {
        return <main>
            <Grid container direction="column"
                sx={{
                    width: "100%",
                    minHeight: "30rem",
                    height: "calc(100vh)",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundImage: "url(" + Wallpaper + ")",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                    //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
                }}>
                <Container sx={{
                    bgcolor: alpha(theme.palette.background.paper, 0.9),
                    minHeight: "20rem",
                    padding: theme.spacing(4), borderRadius: theme.shape.borderRadius, border: 1,
                }} maxWidth="xs">
                    <Box sx={{
                        marginTop: "1rem",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        <Box
                            component={Button}
                            sx={{
                                display: "flex",
                                justifyContent: "center", alignItems: "center", width: "100%",
                            }}>
                            <img src={MainLogo} css={logoMain} />
                        </Box>
                        <Box component="form" onSubmit={postResetButton} noValidate sx={{ marginTop: theme.spacing(1) }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="newPassword"
                                label={t('basic.newPassword')}
                                type="password"
                                id="newPassword"
                                autoComplete="new-password" />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="reNewPassword"
                                label={t('basic.reEnterNewPassword')}
                                type="password"
                                id="reNewPassword"
                                autoComplete="renew-password" />
                            <Typography color={theme.palette.error.main}>{loginMessage}</Typography>
                            <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: theme.spacing(3), mb: theme.spacing(2) }}>
                                {t('basic.changePassword')}
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Grid>
        </main>
    }
    

}
export default NewPasswordRoute;